/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careful_Smart_Rabbit_AnimateInputs */

const fr_careful_smart_rabbit_animate = /** @type {(inputs: Careful_Smart_Rabbit_AnimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours de traitement`)
};

/**

* @param {Careful_Smart_Rabbit_AnimateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const careful_smart_rabbit_animate = /** @type {((inputs?: Careful_Smart_Rabbit_AnimateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careful_Smart_Rabbit_AnimateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_careful_smart_rabbit_animate(inputs)
});